import T from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import MimeTypes from '../../../../../shared/helpers/mime-types';
import navigateTo from '../../../../../shared/helpers/navigate-to';
import { createAndUploadEpisode } from '../../../../../shared/helpers/upload-episode-audio';

import {
  createMarker,
  updateAudioMarkerWithDuration,
  updateAudioMarkerWithMedia,
  fetchEpisodeMarkers,
} from '../../../../../ducks/markers';

class FileUploadButton extends Component {
  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  onFileInputChange = async event => {
    const file = event.target.files[0];
    const {
      onFetchEpisodeMarkers,
      onUpdateAudioMarkerWithDuration,
      onUpdateAudioMarkerWithMedia,
      showId,
    } = this.props;

    if (!file || MimeTypes.Audio.indexOf(file.type) < 0) return;

    this.setState({ loading: true });

    try {
      const episode = await createAndUploadEpisode({
        showId,
        file,
        onFetchEpisodeMarkers,
        onUpdateAudioMarkerWithDuration,
        onUpdateAudioMarkerWithMedia,
      });
      navigateTo(`/episodes/${episode.id}`);
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  clickFileInput = () => {
    this.fileInput.click();
  };

  render() {
    const { disabled } = this.props;
    const { loading } = this.state;

    return (
      <div>
        <input
          type="file"
          accept={MimeTypes.Audio.join(', ')}
          style={{
            display: 'none',
          }}
          onChange={this.onFileInputChange}
          ref={input => {
            this.fileInput = input;
          }}
        />
        {this.props.children({ onClick: this.clickFileInput, disabled, loading })}
      </div>
    );
  }
}

FileUploadButton.propTypes = {
  children: T.func.isRequired,
  disabled: T.bool,
  onCreateMarker: T.func.isRequired,
  onFetchEpisodeMarkers: T.func.isRequired,
  onUpdateAudioMarkerWithDuration: T.func.isRequired,
  onUpdateAudioMarkerWithMedia: T.func.isRequired,
  showId: T.string.isRequired,
};

export default connect(
  () => ({}),
  {
    onCreateMarker: createMarker,
    onFetchEpisodeMarkers: fetchEpisodeMarkers,
    onUpdateAudioMarkerWithDuration: updateAudioMarkerWithDuration,
    onUpdateAudioMarkerWithMedia: updateAudioMarkerWithMedia,
  }
)(FileUploadButton);
